<template>
   <div class="card-block">
      <form autocomplete="off" role="presentation" style="background-color: #f9f9f9; padding: 14px; border-radius: 5px; border: solid 1px #efefef;">
        <div class="form-group row">
          <div class="col-md-12">
            <strong><i class="fas fa-user-friends text-default"></i> {{$lang.EmployeeBoard.BoardDetails.Title}} </strong>
            <div v-if="HasData == true && (this.obj.situacao === null || this.obj.situacao === 0)" class="edit-board">
              <a href="javascript:void(0);" @click="onEdit"><i class="fas fa-edit"></i>&nbsp;<small>{{$lang.EmployeeBoard.BoardDetails.EditLink}}</small></a>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-4">
            <label> {{$lang.EmployeeBoard.BoardDetails.LabelOrder}}:</label>
            <div class="input-group">
              <strong>{{RequestNumber}}</strong>
            </div>
          </div>
          <div class="col-md-4">
            <label> {{$lang.EmployeeBoard.BoardDetails.LabelDateRequest}}:</label>
            <div class="input-group">
              <strong>{{RequestDate}}</strong>
            </div>
          </div>
          <div class="col-md-4">
            <label> {{$lang.EmployeeBoard.BoardDetails.LabelStatus}}:</label>
            <div class="input-group">
              <strong>{{Stage}}</strong>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-4">
            <label> {{$lang.EmployeeBoard.BoardDetails.LabelResponsible}}:</label>
            <div class="input-group">
              <strong>{{Responsible}}</strong>
            </div>
          </div>
          <div class="col-md-4">
            <label> {{$lang.EmployeeBoard.BoardDetails.LabelConstructions}}:</label>
            <div class="input-group">
              <strong>{{ObraRH}}</strong>
            </div>
          </div>
          <div class="col-md-4">
            <label> {{$lang.EmployeeBoard.BoardDetails.LabelPeriod}}:</label>
            <div class="input-group">
              <strong>{{WorkPeriod}}</strong>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-4">
            <label> {{$lang.EmployeeBoard.BoardDetails.LabelClient}}:</label>
            <div class="input-group">
              <strong>{{Client}}</strong>
            </div>
          </div>
          <div class="col-md-4">
            <label> {{$lang.Common.LabelCity}}:</label>
            <div class="input-group">
              <strong>{{City}}</strong>
            </div>
          </div>
          <div class="col-md-4">
            <div class="input-group pt-2">
              <button type="button"
                      v-if="HasData == true && (this.obj.situacao === null || this.obj.situacao <= 0)"
                      class="btn btn-third btn-sm mr-1"
                      v-b-tooltip.hover
                      :title="$lang.EmployeeBoard.BoardDetails.ButtonApproval.Tooltip"
                      @click="onSectionApproval">
                <i class="fas fa-play-circle"></i> {{$lang.EmployeeBoard.BoardDetails.ButtonApproval.Title}}
              </button>
              <b-dropdown variant="danger" no-caret
                      v-if="HasData == true && (this.obj.situacao === null || this.obj.situacao === 0)">
                <template slot="button-content">
                  <i class="fa fa-trash"></i> {{$lang.Common.Buttons.Delete}}
                </template>
                <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
                <b-dropdown-item href="javascript:void(0);" v-on:click="onDelete">{{$lang.Common.Yes}}</b-dropdown-item>
                <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
              </b-dropdown>
              <button type="button"
                      v-if="hasRole(roles.RW_FIN_BOARD_COORD) && HasData === true && this.obj.situacao === 1"
                      class="btn btn-success btn-sm mr-1"
                      v-b-tooltip.hover
                      :title="$lang.EmployeeBoard.BoardDetails.ButtonApprove.Tooltip"
                      @click="onApproval">
                <i class="fas fa-check-circle"></i> {{$lang.EmployeeBoard.BoardDetails.ButtonApprove.Title}}
              </button>
              <button type="button"
                      v-if="hasRole(roles.RW_FIN_BOARD_RH) && HasData === true && this.obj.situacao === 2"
                      class="btn btn-success btn-sm mr-1"
                      v-b-tooltip.hover
                      :title="$lang.EmployeeBoard.BoardDetails.ButtonApprove.Tooltip"
                      @click="onApproval">
                <i class="fas fa-check-circle"></i> {{$lang.EmployeeBoard.BoardDetails.ButtonApprove.Title}}
              </button>
              <button type="button"
                      v-if="hasRole(roles.RW_FIN_BOARD_COORD) && HasData === true && this.obj.situacao === 1"
                      class="btn btn-danger btn-sm mr-1"
                      v-b-tooltip.hover
                      :title="$lang.EmployeeBoard.BoardDetails.ButtonDisapprove.Tooltip"
                      @click="onDisapproval">
                <i class="fas fa-times-circle"></i> {{$lang.EmployeeBoard.BoardDetails.ButtonDisapprove.Title}}
              </button>
              <button type="button"
                      v-if="hasRole(roles.RW_FIN_BOARD_RH) && HasData === true && this.obj.situacao === 2"
                      class="btn btn-danger btn-sm mr-1"
                      v-b-tooltip.hover
                      :title="$lang.EmployeeBoard.BoardDetails.ButtonDisapprove.Tooltip"
                      @click="onDisapproval">
                <i class="fas fa-times-circle"></i> {{$lang.EmployeeBoard.BoardDetails.ButtonDisapprove.Title}}
              </button>
              <button type="button"
                      v-if="HasData == true && this.obj.situacao === 3"
                      class="btn btn-default btn-sm mr-1"
                      v-b-tooltip.hover
                      :title="$lang.EmployeeBoard.BoardDetails.ButtonExport.Tooltip"
                      @click="exportFile = !exportFile">
                <i class="fas fa-file-export"></i> {{$lang.EmployeeBoard.BoardDetails.ButtonExport.Title}}
              </button>
              <button type="button"
                      v-if="HasData == true && this.obj.situacao === 3"
                      class="btn btn-default btn-sm mr-1"
                      v-b-tooltip.hover
                      :title="$lang.EmployeeBoard.BoardDetails.ButtonClone.Tooltip"
                      @click="onClone">
                <i class="fas fa-copy"></i> {{$lang.EmployeeBoard.BoardDetails.ButtonClone.Title}}
              </button>
            </div>
          </div>
        </div>
        <div class="row" v-show="exportFile">
          <div class="col-md-8"></div>
          <div class="col-md-4 d-flex flex-wrap">
            <div class="mr-3">
              <label for="#">{{$lang.EmployeeBoard.BoardDetails.Export.LabelFood}}</label>
              <b-form-input v-model="exportObj.eventFood"
                            style="width: 90px;"
                            :formatter="value => value.toUpperCase()" />
            </div>
            <div class="mr-3" >
              <label for="#"> {{$lang.EmployeeBoard.BoardDetails.Export.LabelMeal}} </label>
              <b-form-input v-model="exportObj.eventMeal"
                            style="width: 90px;"
                            :formatter="value => value.toUpperCase()" />
            </div>
            <div class="mr-3">
              <label for="#"> {{$lang.EmployeeBoard.BoardDetails.Export.LabelBreakfest}} </label>
              <b-form-input v-model="exportObj.eventBreakfest"
                            style="width: 90px;"
                            :formatter="value => value.toUpperCase()" />
            </div>
            <div class="mr-3">
              <label for="#"> {{$lang.EmployeeBoard.BoardDetails.Export.LabelLunch}} </label>
              <b-form-input v-model="exportObj.eventLunch"
                            style="width: 90px;"
                            :formatter="value => value.toUpperCase()" />
            </div>
            <div class="mr-3">
              <label for="#"> {{$lang.EmployeeBoard.BoardDetails.Export.LabelTransport}} </label>
              <b-form-input v-model="exportObj.eventTransport"
                            style="width: 90px;"
                            :formatter="value => value.toUpperCase()" />
            </div>
          </div>
          <div class="col-md-8"></div>
          <div class="col-md-4 form-inline justify-content-end mt-3">
            <div>
              <label for="#">Qtd. Dias</label>
              <b-form-input type="number"
                            v-model="exportObj.days"
                            style="width: 80px;"
                            class="mr-2" />
            </div>
            <div class="align-self-end">
              <button type="button"
                      class="btn btn-default btn-sm"
                      :disabled="
                        !(
                          ((exportObj.eventFood || exportObj.eventBreakfest) &&
                            !(exportObj.eventMeal || exportObj.eventLunch || exportObj.eventTransport)
                          ) ||
                          (exportObj.days &&
                            (exportObj.eventMeal || exportObj.eventLunch || exportObj.eventTransport)
                          )
                        )
                      "
                      @click="onExport">
                <i class="fas fa-check"></i> Exportar
              </button>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-12">
            <label>
              Observações:&nbsp;
              <a v-if="showObservations == false" href="javascript:void(0);" @click="showObservations = true">
                <i class="fas fa-plus-square"></i>
              </a>
              <a v-else href="javascript:void(0);" @click="showObservations = false">
                <i class="fas fa-minus-square"></i>
              </a>
            </label>
            <div v-show="showObservations" class="input-group">
              <span class="edit-observations">{{Observations}}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
</template>

<script>
import Roles from '@/shared/utils/roles'
import PermisionMixin from '@/store/module/permission/mixin'

export default {
  name: 'BoardDetails',
  mixins: [ PermisionMixin ],
  data () {
    return {
      showObservations: false,
      roles: Roles,
      exportFile: false,
      exportObj: {
        days: 0,
        eventFood: '',
        eventMeal: '',
        eventBreakfest: '',
        eventLunch: '',
        eventTransport: ''
      }
    }
  },
  props: {
    obj: Object
  },
  computed: {
    HasData () {
      let result = false
      if (this.obj) {
        result = true
      }
      return result
    },
    RequestNumber () {
      let result = ''
      if (this.obj) {
        result = this.obj.pedido
      }
      return result
    },
    RequestDate () {
      let result = ''
      if (this.obj && this.obj.dataCriacao) {
        result = this.moment(this.obj.dataCriacao).format('DD/MM/YYYY HH:mm')
      }
      return result
    },
    Responsible: function () {
      let result = ''
      if (this.obj && this.obj.responsavel) {
        result = this.obj.responsavel.codigo + '-' + this.obj.responsavel.nome
      }
      return result
    },
    ObraRH: function () {
      let result = ''
      if (this.obj && this.obj.obraRH) {
        if (this.obj.obraRH.codigo) {
          result = this.obj.obraRH.codigo + '-'
        }
        result += this.obj.obraRH.nome
      }
      return result
    },
    WorkPeriod: function () {
      let result = ''
      if (this.obj && this.obj.inicioObra && this.obj.terminoObra) {
        result = this.moment(this.obj.inicioObra).format('DD/MM/YYYY') + ' à ' + this.moment(this.obj.terminoObra).format('DD/MM/YYYY')
      }
      return result
    },
    Client: function () {
      let result = ''
      if (this.obj && this.obj.clienteRH) {
        result = this.obj.clienteRH.nome
      }
      return result
    },
    City: function () {
      let result = ''
      if (this.obj && this.obj.cidade && this.obj.cidade.nome) {
        result = this.obj.cidade.nome + ' - ' + this.obj.cidade.estado.sigla
      }
      return result
    },
    Observations: function () {
      let result = ''
      if (this.obj) {
        result = this.obj.observacao
      }
      return result
    },
    Stage: function () {
      let result = ''
      if (this.obj && this.obj.hasOwnProperty('situacao')) {
        switch (parseInt(this.obj.situacao)) {
          case 0: result = this.$lang.EmployeeBoard.TextSituation0
            break
          case 1: result = this.$lang.EmployeeBoard.TextSituation1
            break
          case 2: result = this.$lang.EmployeeBoard.TextSituation2
            break
          case 3: result = this.$lang.EmployeeBoard.TextSituation3
            break
          case -1: result = this.$lang.EmployeeBoard.TextSituation_1
            break
          case -2: result = this.$lang.EmployeeBoard.TextSituation_2
            break
          default: result = this.$lang.EmployeeBoard.TextSituation_X
            break
        }
      }
      return result
    }
  },
  mounted () {
    this.showObservations = false
  },
  methods: {
    onAddBoard () {
      this.$emit('New')
    },
    onEdit () {
      if (this.HasData) {
        this.$emit('Edit', this.obj)
      }
    },
    onDelete () {
      this.$emit('Delete', this.obj)
    },
    onSectionApproval () {
      this.$emit('SectionApproval', this.obj)
    },
    onApproval () {
      this.$emit('Approval', this.obj)
    },
    onDisapproval () {
      this.$emit('Disapproval', this.obj)
    },
    onClone () {
      this.$emit('Clone', this.obj)
    },
    onExport () {
      this.$emit('Export', this.exportObj)
    }
  }
}
</script>
<style scoped>
.edit-board {
  display: block;
  position: absolute;
  text-align: right;
  width: 100%;
  right: 15px;
  top: -1px;
}
.edit-board i {
  font-size: 10px;
}
.edit-observations {
  background-color: #fff;
  padding: 10px;
  border: solid 1px #efefef;
  border-radius: 4px;
  width: 100%;
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/employeeboard/board/components/boarddetails/boarddetails.vue